import { render, staticRenderFns } from "./UiTextarea.vue?vue&type=template&id=7c23060c&scoped=true"
import script from "./UiTextarea.vue?vue&type=script&lang=js"
export * from "./UiTextarea.vue?vue&type=script&lang=js"
import style0 from "./UiTextarea.vue?vue&type=style&index=0&id=7c23060c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23060c",
  null
  
)

export default component.exports